<dialog-header
  [dialogRef]="dialogRef"
  [headerKey]="promptData ? promptData.header : 'PROMPT.HEADER'"
  [headerParam]="promptData ? promptData.headerParam : undefined"
></dialog-header>
<div mat-dialog-content>
  <p *ngIf="isHtml" [innerHTML]="getContent()"></p>
  <p *ngIf="!isHtml" >{{ getContent() }}</p>
  <buttons-wrapper>
    <button *ngIf="!promptData || (promptData && !promptData.hideCancelBtn)" mat-flat-button mat-dialog-close>{{ (promptData ? promptData.cancelBtn! : 'PROMPT.CANCEL') | translate }}</button>
    <button mat-flat-button color="primary" [mat-dialog-close]="true">{{ (promptData ? promptData.confirmBtn! : 'PROMPT.OK') | translate }}</button>
  </buttons-wrapper>
</div>
